(ns common.schema.entities.survey.survey-cc-type
  "Who is copied on a survey profile's invitations and reminders.

   The profile already names the people responsible for it - `our manager`
   and `other managers` - so a separate list of addresses would mostly
   restate them. The mode picks from what the profile already knows, and
   `:survey-profile/other-cc-recipients` covers anyone that naming does not
   reach.")

(def options
  [{:key   :cc-type/none
    :ord   0.0
    :label "No copy"}
   {:key   :cc-type/primary-manager
    :ord   1.0
    :label "Our manager"}
   {:key   :cc-type/all-managers
    :ord   2.0
    :label "All managers"}
   {:key   :cc-type/other-recipients
    :ord   3.0
    :label "Other CC recipients only"}
   {:key   :cc-type/all-managers-and-others
    :ord   4.0
    :label "All managers and other CC recipients"}])

(def by-key
  (->> options
       (map (juxt :key identity))
       (into {})))

(defn label
  [cc-type]
  (:label (get by-key cc-type)))

(def includes-primary-manager?
  #{:cc-type/primary-manager
    :cc-type/all-managers
    :cc-type/all-managers-and-others})

(def includes-other-managers?
  #{:cc-type/all-managers
    :cc-type/all-managers-and-others})

(def includes-other-recipients?
  #{:cc-type/other-recipients
    :cc-type/all-managers-and-others})
